import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenBusinessPageBreadcrumbs } from '@/pages/Business/config';
import { NavigateFunction } from 'react-router-dom';

export const childrenTransitControlPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessPageBreadcrumbs(navigate),
  {
    label: 'Control de tránsito',
    onClick: () => navigate('/business/transit-control'),
  },
];
